export enum AnalyticsEventTypes {
  Video = 'video',
  Project = 'project',
  Page = 'page',
  Link = 'link',
  Audio = 'audio',
  Activity = 'activity',
  Auth = 'auth',
}
